<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="主键" prop="id">
                <Input type="text" v-model="searchForm.id" placeholder="请输入" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="订单序列号" prop="orderSeqNo">
                <Input type="text" v-model="searchForm.orderSeqNo" placeholder="请输入订单序列号" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="用户id" prop="registerId">
                  <Input type="text" v-model="searchForm.registerId" placeholder="请输入用户id" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="订单类型" prop="subBizType">
                   <Select v-model="searchForm.subBizType">
                    <Option value="">全部</Option>
                    <Option value="0501">问律师服务（30分钟）</Option>
                    <Option value="0502">问律师服务（60分钟）</Option>
                    <Option value="0503">合同审核</Option>
                    <Option value="0504">侵权下架</Option>
                    <Option value="0505">侵权判定</Option>
                    <Option value="0506">出具律师函</Option>
                  </Select>
                </Form-item>
                <Form-item label="用户电话" prop="callbackMobilePhone">
                  <Input type="text" v-model="searchForm.callbackMobilePhone" placeholder="请输入用户电话" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="订单状态" prop="orderStatus">
                  <Select v-model="searchForm.orderStatus">
                    <Option value="">全部</Option>
                    <Option value="paid">等待服务</Option>
                    <Option value="in_service">服务中</Option>
                    <Option value="finish_service">服务完成</Option>
                  </Select>
                </Form-item>
                <Form-item label="服务商" prop="serviceMan">
                  <Input type="text" v-model="searchForm.serviceMan" placeholder="请输入服务者（服务商或者律师）" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="服务商电话"  prop="serviceManPhone">
                  <Input type="text" v-model="searchForm.serviceManPhone" placeholder="请输入服务者电话" clearable style="width: 200px"/>
                </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal title="添加服务记录" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="订单序列号" prop="orderSeqNo" >
          <Input v-model="form.orderSeqNo" style="width:100%"/>
        </FormItem>
        <FormItem label="记录状态名称" prop="recordCode" >
          <Select v-model="form.recordCode">
            <Option value="start_service">开始服务</Option>
            <Option value="first_service">初次联系</Option>
            <Option value="in_service">服务中</Option>
            <Option value="finish_service">服务完成</Option>
          </Select>
        </FormItem>
        <FormItem label="记录完成状态" prop="recordStatus" >
          <Select v-model="form.recordStatus">
            <Option value="0">未开始</Option>
            <Option value="1">进行中</Option>
            <Option value="2">完成</Option>
          </Select>
        </FormItem>
        <FormItem label="服务商" prop="serviceMan" >
          <Input v-model="form.serviceMan" style="width:100%"/>
        </FormItem>
        <FormItem label="服务商电话" prop="serviceManPhone" >
          <Input v-model="form.serviceManPhone" style="width:100%"/>
        </FormItem>
        <FormItem label="服务记录时间" prop="lawyerServiceTime" >
            <DatePicker type="datetime" format="yyyy-MM-dd HH:mm:ss" @on-change="selectLawyerServiceTime" v-model="form.lawyerServiceTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="服务记录" prop="lawyerServiceLog" >
            <textarea v-model="form.lawyerServiceLog" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
    <Modal title="详情" v-model="modalormDetailVisible" :mask-closable='false' :width="700">
      <Form ref="formDetail" :model="formDetail" :label-width="100" >
        <table style="width:670px;table-layer:fixed;">
          <tr>
            <td colspan="3"><h3>订单基本信息：</h3></td>
            <td style="text-align: right;"><Button type="primary" :loading="submitLoading" @click="edit(formDetail.order.orderSeqNo,formDetail.order.serviceMan,formDetail.order.serviceManPhone)">添加服务记录</Button></td>
          </tr>
          <tr>
            <td style="text-align: right;">订单序列号:</td><td>{{this.formDetail.order.orderSeqNo}}</td>
            <td style="text-align: right;">订单类型:</td><td>{{this.formDetail.order.subBizType}}</td>
          </tr>
          <tr>
            <td style="text-align: right;">用户id:</td><td>{{this.formDetail.order.registerId}}</td>
            <td style="text-align: right;">用户电话:</td><td>{{this.formDetail.order.callbackMobilePhone}}</td>
          </tr>
          <tr>
            <td style="text-align: right;">预约时间:</td><td>{{this.formDetail.order.appointment}}</td>
            <td style="text-align: right;">订单状态:</td><td>{{this.formDetail.order.orderStatus}}</td>
          </tr>
          <tr v-if="this.formDetail.askLawyer">
            <td style="text-align: right;">问律师范围:</td>
            <td colspan="3" v-if="formDetail.askLawyer.askScope=='found_torted'">发现被侵权</td>
            <td colspan="3" v-if="formDetail.askLawyer.askScope=='tort_off_shelf'">侵权下架</td>
            <td colspan="3" v-if="formDetail.askLawyer.askScope=='enterprise_copyright'">企业版权</td>
            <td colspan="3" v-if="formDetail.askLawyer.askScope=='other'">其他</td>
            <td colspan="3" v-if="formDetail.askLawyer.askScope!='found_torted' && formDetail.askLawyer.askScope!='tort_off_shelf' && formDetail.askLawyer.askScope!='enterprise_copyright' && formDetail.askLawyer.askScope!='other'">{{this.formDetail.askLawyer.askScope}}</td>
          </tr>
          <tr v-if="this.formDetail.contract">
            <td width="12%" style="text-align: right;">合同类型:</td>
            <td width="38%" v-if="formDetail.contract.contractType=='contract_audit'">合同审核</td>
            <td width="38%" v-if="formDetail.contract.contractType=='contract_ghostwrite'">代写合同</td>
            <td width="38%" v-if="formDetail.contract.contractType!='contract_ghostwrite' && formDetail.contract.contractType!='contract_audit'">{{this.formDetail.contract.contractType}}</td>
            <td width="12%" style="text-align: right;">合同地址:</td><td style="width:38%;word-wrap:break-word;word-break:break-all;"><a :href="''+formDetail.contract.contractUrl+''"  target="_blank">{{this.formDetail.contract.contractUrl}}</a></td>
          </tr>
          <tr v-if="this.formDetail.tortJudge">
            <td style="text-align: right;">侵权连接:</td><td colspan="3" style="width:88%;word-wrap:break-word;word-break:break-all;"><a :href="''+formDetail.tortJudge.tortUrl+''"  target="_blank">{{this.formDetail.tortJudge.tortUrl}}</a></td>
          </tr>
          <tr>
            <td style="text-align: right;">问题描述:</td><td colspan="3" style="width:88%;word-wrap:break-word;word-break:break-all;">{{this.formDetail.order.questionDesc}}</td>
          </tr>
          <tr>
            <td style="text-align: right;">服务商:</td><td>{{this.formDetail.order.serviceMan}}</td>
            <td style="text-align: right;">服务商电话:</td><td>{{this.formDetail.order.serviceManPhone}}</td>
          </tr>
          <tr>
            <td style="text-align: right;">服务开始时间:</td><td>{{this.formDetail.order.serviceStart}}</td>
            <td style="text-align: right;">服务结束时间:</td><td>{{this.formDetail.order.serviceEnd}}</td>
          </tr>
          <tr>
            <td colspan="4"><h3>服务状态：</h3></td>
          </tr>
          <tr v-for="(n,i) in this.formDetail.statusRecords">
            <td style="text-align: right;">{{n.name}}:</td>
            <td colspan="3" v-if= "n.status == 0">未开始</td>
            <td colspan="3" v-if= "n.status == 1">进行中</td>
            <td colspan="3" v-if= "n.status == 2">已完成</td>
          </tr>
          <tr>
            <td colspan="4"><h3>服务记录：</h3></td>
          </tr>
          <tr v-for="(n,i) in this.formDetail.list">
            <td style="text-align: right;">服务记录时间:</td> <td>{{n.lawyerServiceTime}}:</td>
            <td style="text-align: right;">服务记录:</td> <td>{{n.lawyerServiceLog}}:</td>
          </tr>
        </table>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalormDetailVisible=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "LawOrder",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalVisible: false, // 保存记录显示
      modalormDetailVisible: false, // 详情显示
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "create_date", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        orderSeqNo: "",
        serviceMan: "",
        serviceManPhone: "",
        lawyerServiceTime: null,
        lawyerServiceLog: "",
        recordCode: "",
        recordStatus: "",
      },
      formDetail: { // 详情数据
        order: [],
        askLawyer: [],
        contract: [],
        tortJudge: [],
        statusRecords: {},
        list: {},
      },
      // 表单验证规则
      formValidate: {
        serviceMan: [{ required: true, message: "不能为空", trigger: "blur" }],
        serviceManPhone: [{ required: true, message: "不能为空", trigger: "blur" }],
        lawyerServiceTime: [{ required: true, message: "不能为空", trigger: "blur" }],
        lawyerServiceLog: [{ required: true, message: "不能为空", trigger: "blur" }],
        recordCode: [{ required: true, message: "不能为空", trigger: "blur" }],
        recordStatus: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "主键ID",
          key: "id",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "订单序列号",
          key: "orderSeqNo",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户id",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户电话",
          key: "callbackMobilePhone",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "订单类型",
          key: "subBizType",
          minWidth: 120,
          sortable: false,
          render(h, params){
            let subBizType = '';
            let style = '';
            if(params.row.subBizType == '0501'){
              subBizType = '问律师服务（30分钟）';
            }
            if(params.row.subBizType == '0502'){
              subBizType = '问律师服务（60分钟）';
            }
            if(params.row.subBizType == '0503'){
              subBizType = '合同审核';
            }
            if(params.row.subBizType == '0504'){
              subBizType = '侵权下架';
            }
            if(params.row.subBizType == '0505'){
              subBizType = '侵权判定';
            }
            if(params.row.subBizType == '0506'){
              subBizType = '出具律师函';
            }
            return h('span', {
              style: style
            }, subBizType);
          }
        },
        {
          title: "询问人行业",
          key: "askerIndustry",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "预约时间",
          key: "appointment",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "订单状态",
          key: "orderStatus",
          minWidth: 120,
          sortable: false,
          render(h, params){
            let orderStatus = '';
            let style = '';
            if(params.row.orderStatus == 'paid'){
              orderStatus = '等待服务';
            }
            if(params.row.orderStatus == 'in_service'){
              orderStatus = '服务中';
            }
            if(params.row.orderStatus == 'finish_service'){
              orderStatus = '服务完成';
            }
            return h('span', {
              style: style
            }, orderStatus);
          }
        },
        {
          title: "服务商",
          key: "serviceMan",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "服务者电话",
          key: "serviceManPhone",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "服务开始时间",
          key: "serviceStart",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "服务结束时间",
          key: "serviceEnd",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          fixed: 'right',
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row.orderSeqNo,params.row.serviceMan,params.row.serviceManPhone);
                    }
                  }
                },
                "添加记录"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.orderSeqNo);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    selectLawyerServiceTime(v) {
      if (v) {
        this.form.lawyerServiceTime = v;
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
       this.getRequest("/lawOrder/getByPage", this.searchForm).then(res => {
         this.loading = false;
         if (res.success) {
           this.data = res.result.records;
           this.total = res.result.total;
         }
       });
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.postRequest("/lawOrder/saveLawOrderRecord", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
          });
        }
      });
    },
    detail(orderSeqNo) {
      this.getRequest("/lawOrder/get/"+orderSeqNo).then(res => {
        this.loading = false;
        if (res.success) {
          this.formDetail = res.result;
          this.modalormDetailVisible = true;
        }
      });
    },
    edit(orderSeqNo,serviceMan,serviceManPhone) {
      this.modalVisible = true;
      this.form.orderSeqNo = orderSeqNo;
      this.form.lawyerServiceTime = null;
      this.form.serviceMan = serviceMan;
      this.form.serviceManPhone = serviceManPhone;
      this.form.lawyerServiceTime = null;
      this.form.lawyerServiceLog = null;
      this.form.recordCode = null;
      this.form.recordStatus = null;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>